import classNames from '@/utils/classNames';
import { type ComponentPropsWithRef } from 'react';
import styles from './Neutral.module.css';

// Neutral components remove all their default styles, so they look like standard text

export const NeutralLink = ({ className, ...props }: ComponentPropsWithRef<'a'>) => (
    <a className={classNames(styles.neutral, className)} {...props} />
);

// todo - remove uses
export const NeutralButton = ({ className, ...props }: ComponentPropsWithRef<'button'>) => (
    <button className={classNames(styles.neutral, className)} {...props} />
);
